import { useCallback, useMemo, useState } from 'react';
import useSWR from 'swr';
import { useClient } from '../../../../hooks/useClient';
import { UserRoutineHistory } from '../../../../types/externalUser';
import { ProfileOrganization } from '../types';
import { getMonthGridRange } from '../utils';

export const useRoutinesCalendar = ({
  organization,
  externalUserId,
}: {
  organization: ProfileOrganization;
  externalUserId: string | undefined;
}) => {
  const { get } = useClient();

  // State for controlled routines calendar
  const [routinesCalendarDate, setRoutinesCalendarDate] = useState<Date>(new Date());

  const routinesDateRange = useMemo(() => {
    return getMonthGridRange(routinesCalendarDate);
  }, [routinesCalendarDate]);

  const routineHistoryUrl = useMemo(() => {
    if (!organization || !externalUserId) return null;
    const startDate = routinesDateRange.start.toISOString();
    const endDate = routinesDateRange.end.toISOString();
    return `/organizations/${organization.id}/external-users/${externalUserId}/routine-history?startDate=${startDate}&endDate=${endDate}`;
  }, [organization, externalUserId, routinesDateRange]);

  const { data: routineHistory, isLoading: routineHistoryLoading } = useSWR(routineHistoryUrl, get<UserRoutineHistory[]>);

  const handleRoutinesCalendarNavigate = useCallback((newDate: Date) => {
    setRoutinesCalendarDate(newDate);
  }, []);

  return { routinesCalendarDate, routineHistory, routineHistoryLoading, handleRoutinesCalendarNavigate };
};
